/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExclusionTerm } from './ExclusionTerm';
import {
    ExclusionTermFromJSON,
    ExclusionTermFromJSONTyped,
    ExclusionTermToJSON,
    ExclusionTermToJSONTyped,
} from './ExclusionTerm';

/**
 * 
 * @export
 * @interface GetDocumentExclusionTerms200Response
 */
export interface GetDocumentExclusionTerms200Response {
    /**
     * List of document exclusion terms
     */
    data?: Array<ExclusionTerm>;
}

/**
 * Check if a given object implements the GetDocumentExclusionTerms200Response interface.
 */
export function instanceOfGetDocumentExclusionTerms200Response(value: object): value is GetDocumentExclusionTerms200Response {
    return true;
}

export function GetDocumentExclusionTerms200ResponseFromJSON(json: any): GetDocumentExclusionTerms200Response {
    return GetDocumentExclusionTerms200ResponseFromJSONTyped(json, false);
}

export function GetDocumentExclusionTerms200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentExclusionTerms200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ExclusionTermFromJSON)),
    };
}

export function GetDocumentExclusionTerms200ResponseToJSON(json: any): GetDocumentExclusionTerms200Response {
    return GetDocumentExclusionTerms200ResponseToJSONTyped(json, false);
}

export function GetDocumentExclusionTerms200ResponseToJSONTyped(value?: GetDocumentExclusionTerms200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ExclusionTermToJSON)),
    };
}

